define('pwa/plugin/multiple-booking/controller/MultipleBookingController',['require','lib/controller/BaseController','pwa/plugin/multiple-booking/view/MultipleBookingLayoutView'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var MultipleBookingLayoutView = require('pwa/plugin/multiple-booking/view/MultipleBookingLayoutView');

    /**
     * @class TicketController
     */
    return BaseController.extend({

        cart: function () {
            var _this = this;
            var view = new MultipleBookingLayoutView({
                'collection': this.getOption('collection'),
            });
            this.listenTo(view, 'checkout', function () {
                _this.triggerMethod('checkout');
            });
            this.getMainLayout().getContentRegion().show(view);
        },

    });

});
